import { Injectable, inject } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LogRotina} from '../model/log-rotina.model';

@Injectable({
  providedIn: 'root'
})
export class LogRotinaService {
  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/log-rotina`;

  buscarLogsPorRotinaId(rotinaId: number): Observable<LogRotina[]> {
    return this.http.get<LogRotina[]>(`${this.urlBase}/buscar/${rotinaId}`);
  }
}
